import React, { Component } from 'react';
import { Route,Switch ,BrowserRouter, Redirect} from 'react-router-dom';
import './bundle.scss';
import AOS from 'aos';
import Home from './themes/orsity/pages/home/home';
import Blog from './themes/orsity/pages/blog/blog';
import Post from './themes/orsity/pages/blog/post';
import PostUpload from './themes/orsity/pages/postupload/postupload';
import PostEdit from './themes/orsity/pages/postedit/postedit';
import PostCatEdit from './themes/orsity/pages/postedit/postcatedit';
import PostCategory from './themes/orsity/pages/blog/postcategory';
import Contact from './themes/orsity/pages/contact/contact';
import Privacy from './themes/orsity/pages/privacy/privacy';
import Terms from './themes/orsity/pages/terms/terms';
import SignIn from './themes/orsity/pages/signin/signin';
import SignUp from './themes/orsity/pages/signup/signup';
import Pricing from './themes/orsity/pages/pricing/pricing';
import SignupFlow from './themes/orsity/pages/signupflow/signupflow';
import ForgotPassword from './themes/orsity/pages/forgotpassword/forgotpassword';
import ResetPassword from './themes/orsity/pages/resetpassword/resetpassword';
import CourseUpload from './themes/orsity/pages/courseupload/courseupload';
import Courses from './themes/orsity/pages/courses/courses';
import CourseInfo from './themes/orsity/pages/courseinfo/courseinfo';
import ProfileSettings from './themes/orsity/pages/profilesettings/profilesettings';
import CourseEdit from './themes/orsity/pages/courseedit/courseedit';
import ManageUser from './themes/orsity/pages/manageuser/manageuser';
import Changeplan from './themes/orsity/pages/changeplan/changeplan';
import Privateroute,{Publicroute} from './privateroute';
import Videoplaylist from './themes/orsity/pages/videoplaylist';
import About from './themes/orsity/pages/about/about';
import Dashboard from './themes/orsity/pages/dashboard';
import LearningPaths from "./themes/orsity/pages/learningpaths/learningpaths";
import ErrorPage from './themes/orsity/pages/errorpage/errorpage';

export default class App extends Component{
  componentWillMount() {
    AOS.init();
  }

  render(){
    return(
      <BrowserRouter>
      <Switch>
        <Route path="/error" component={ErrorPage} />
        <Route path="/reset-password" component={ResetPassword} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/subscriptions" component={SignupFlow} />
        <Route path="/learningpaths" component={LearningPaths} />
        <Route path="/terms" component={Terms} />
        <Route exact path="/blog" component={Blog} />
        <Route exact path="/blog/:slug" component={Post} />
        <Route exact path="/blog/category/:slug" component={PostCategory} />
        <Route exact path="/uploadpost" component={PostUpload} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/contact" component={Contact} />
        <Route path="/about" component={About} />
        <Route path="/pricing" component={Pricing} />
        <Route path="/signin" component={SignIn} />
        <Route path="/signup" component={SignUp} />
        <Route exact path="/courses/:slug" component={CourseInfo} />
        <Route exact path="/courses/:slug/lectures" component={Videoplaylist} />
        <Route path="/uploadcourse" component={CourseUpload} />
        <Route path="/editcourse/:slug" component={CourseEdit} />
        <Route path="/editpost/:slug" component={PostEdit} />
        <Route path="/editpostcat/:slug" component={PostCatEdit} />
        <Route path="/courses" component={Courses} />
        <Route path="/manageuser/:slug" component={ManageUser} />
        <Privateroute path="/dashboard" component={Dashboard} />
        <Privateroute path="/settings" component={ProfileSettings} />
        <Privateroute path="/change-plan" component={Changeplan} />
        <Route exact path="/" component={Home} />
        {/* <Route path="*" component={Home} /> */}
        <Redirect from="*" to="/error" />
      </Switch>
    </BrowserRouter>
    )
  }
}